import http from "../http-common";

class RoleService {
  getAll() {
    return http.get("/roles/search");
  }
}

export default new RoleService();